import { t } from "i18n/i18n";
import { storeApi } from "store/index";
import {
  selectPageGroupIdsByPage,
  selectSectionUserIdsForPage,
  selectStudentsWithSectionActivityInCurrentSection,
} from "store/selectors";
import { useCountSelector, useListSelector, usePromiseEffect } from "store/store-hooks";

export const CopyPageGroupsSummary = ({ pageId }: { pageId: string }) => {
  const {
    data: loadedPageId,
    isLoading,
    error,
  } = usePromiseEffect(async () => {
    // Source memberships are not included in the destination page's normal load.
    await Promise.all([
      storeApi.page_groups.list({ page_id: pageId }, { skipToast: true }),
      storeApi.page_group_users.list({ page_group__page_id: pageId }, { skipToast: true }),
    ]);
    return pageId;
  }, [pageId]);
  const groupCount = useCountSelector((state) => selectPageGroupIdsByPage(state, pageId));
  const groupedIds = useListSelector((state) => selectSectionUserIdsForPage(state, pageId));
  // TODO: Use selectStudentSectionUserIdsInCurrentSection once #5359 lands.
  const students = useListSelector(selectStudentsWithSectionActivityInCurrentSection, [
    "section_user_id",
  ]);
  const groupedIdSet = new Set(groupedIds);
  const assignedCount = students.filter((student) =>
    groupedIdSet.has(student.section_user_id),
  ).length;

  let summary: string;
  if (isLoading || (!error && loadedPageId !== pageId)) {
    summary = t("group_configuration_card.summary_loading");
  } else if (error) {
    summary = t("group_configuration_card.summary_unavailable");
  } else {
    summary = t("group_configuration_card.copy_preview", {
      students: t("group_configuration_card.summary_students", { count: assignedCount }),
      groups: t("group_configuration_card.summary_groups", { count: groupCount }),
      unassigned: students.length - assignedCount,
    });
  }

  return <p className="body-xs text-black-tint-40">{summary}</p>;
};
